<template>
  <div class="integrityIndex">
    <!-- 返回导航栏 -->
    <div class="wrapper-box">
      <div class="titles">
        诚信指数：
        <span>{{integrityIndex.score ? toFixed(integrityIndex.score,2) : 10}}</span>
      </div>
      <div class="desc">(诚信指数=规范x0.3+品质x0.4+体验x0.3)</div>
      <div class="price-box">
        <rtext :textColor="'#ffffff'" :textSize="12" style="margin-right:7px;margin-bottom: 12px;">规范: {{(integrityIndex.standardScore == 0 || integrityIndex.standardScore) ? integrityIndex.standardScore : 0}}</rtext>
        <rtext :textColor="'#ffffff'" :textSize="12" style="margin-right:7px;margin-bottom: 12px;">品质: {{(integrityIndex.qualityScore == 0 || integrityIndex.qualityScore) ? integrityIndex.qualityScore : 0}}</rtext>
        <rtext :textColor="'#ffffff'" :textSize="12" style="margin-right:7px;margin-bottom: 12px;">体验: {{(integrityIndex.experienceScore == 0 || integrityIndex.experienceScore) ? integrityIndex.experienceScore : 0}}</rtext>
      </div>
      <div class="excel-title">近 6 个月诚信指数变化</div>
      <div style="height: 210px;">
        <lineCharts :interval="1" :showYear="false" :data="monthData" :color="color" :unit="'家'"/>
      </div>
    </div>
    <!-- tab切换区域 -->
    <div class="maincon-box">
      <tab :tabList="rankingTab" :name="'rankingTab'" @onSwitch="myPending"></tab>
      <div class="standard-box" v-if="currentIndex == 0">
        <div class="small-titles">共 {{deductList.length}} 条扣分记录</div>
        <div class="lists-box">
          <!-- <van-list
            v-model="deductLoading"
            :finished="deductFinished"
            :finished-text="deductFinishedText"
            @load="deductLoadMore"
            v-if="deductList.length > 0"
          > -->
          <div v-for="(items,index) in deductList" :key="index" @click="goDeductDetail(items.id)">
            <div class="items-box" >
              <div class="left-box">
                <div class="title">{{items.groupName}}</div>
                <div class="dates">{{items.differenceStr}}</div>
              </div>
              <div class="right-box">
                <div class="price-box">
                  <div :class="Number(items.score) > 0 ? 'price colorRed' : 'price'">-{{toFixed(items.score,1)}}</div>
                  <img src="../../assets/travelAgency/ic_righticon.png" alt class="img-right" />
                </div>
                <div class="status">{{items.stateName}}</div>
              </div>
            </div>
            <rline  v-if="index < deductList.length - 1"></rline>
          </div>
          <!-- </van-list> -->
        </div>
      </div>
      <div class="quality-box" v-if="currentIndex == 1">
        <div class="small-titles">共 {{quanlityList.length}} 次打分</div>
         <!-- <van-list
            v-model="quanlityLoading"
            :finished="quanlityFinished"
            :finished-text="quanlityFinishedText"
            @load="quanlityLoadMore"
            v-if="quanlityList.length > 0"
          > -->
          <div class="list-items-box" v-for="(items,index) in quanlityList" :key="index">
            <div class="info-box">
              <div class="desc-box">
                <div class="person">评分专员：{{items.employeeName}}</div>
                <div class="pricestand" v-if="items.normaName">评分标准：《{{items.normaName}}》</div>
                <div class="dates">{{items.ratingTime}}</div>
              </div>
              <div class="price-box">
                <div class="price">{{toFixed(items.score,1)}}</div>
                <div class="status">生效中</div>
              </div>
            </div>
            <div class="lists-box">
              <div v-for="(lists,idx) in items.details" :key="idx">
                <div class="items-box" >
                  <div class="namess">{{lists.groupName}}</div>
                  <div :class="Number(lists.deductScore) > 0 ? 'price colorgreen' : (Number(lists.deductScore) == 0 ? 'price greycolor' : 'price')">{{Number(lists.deductScore) > 0 ? '+' : (Number(lists.deductScore) == 0 ? '' : '-')}}{{toFixed(lists.deductScore,1)}}</div>
                </div>
              </div>
            </div>
            <rline v-if="index < quanlityList.length - 1"/>
          </div>
         <!-- </van-list> -->
      </div>
      <div class="experience-box" v-if="currentIndex == 2">
        <div class="price">{{(integrityIndex.experienceScore == 0 || integrityIndex.experienceScore) ? toFixed(integrityIndex.experienceScore,1) : 0}}</div>
        <div class="desc">由游云南APP游客评价打分得出</div>
      </div>
    </div>
  </div>
</template>
<script>
    import tab from 'comps/tab';
    import lineCharts from './components/lineChartss'
    import api from '../../service/modules/travel'
    import rline from './components/line'
    import rtext from './components/text';
    export default {
        components: {
            tab,
            lineCharts,
            rline,
            rtext
        },

        data () {
            return {
                rankingTab: ['规范', '品质', '体验'],
                currentIndex: 1,
                // 折线图
                monthData: [],
                color: 'white',
                deductList: [],
                // deductPagination: { 'currentPage': 0,
                //                     'pageSize': 10000,
                //                     'total': 0,
                //                     'totalPage': 1 },
                // deductLoading: false,
                // deductFinished: false,
                // deductFinishedText: '没有更多',
                // quanlityPagination: {
                //     'currentPage': 0,
                //     'pageSize': 10000,
                //     'total': 0,
                //     'totalPage': 1
                // },
                // quanlityLoading: false,
                // quanlityFinished: false,
                // quanlityFinishedText: '没有更多',
                quanlityList: [],
                integrityIndex: {}

            };
        },

        computed: {},

        watch: {},

        methods: {
            // 扣分详情页
            goDeductDetail (idx) {
                console.log(`${this.globalApp.getSystemInfo().host}web/#/integrity/pointDetail?id=${idx}`)
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/integrity/pointDetail?id=${idx}`,
                        isFullScreen: 0,
                        setTitle: '',
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            myPending (index) {
                this.currentIndex = index;
            },
            // 诚信指数扣分列表
            getCreditIndexDeductionList () {
                api.getCreditIndexDeductionList({ pageIndex: 1, pageSize: 10000, creditCode: this.creditCode }).then(res => {
                    if (res.ret === 0) {
                        // this.deductPagination = res.data.pageination;
                        // this.deductList = [...this.deductList, ...res.data.list];
                        // this.deductLoading = false;
                        // if (this.deductPagination.currentPage >= this.deductPagination.totalPage) {
                        //     this.deductFinished = true;
                        // }
                        for (let i = 0; i < res.data.list.length; i++) {
                            res.data.list[i].differenceStr = this.formatDate2(new Date(res.data.list[i].illegalDate))
                        }
                        this.deductList = res.data.list
                    }
                })
            },
            // // 诚信指数扣分列表加载更多
            // deductLoadMore () {
            //     this.getCreditIndexDeductionList()
            // },
            // 诚信指数企业评分详情
            getGradeIndex () {
                api.getGradeIndex({ creditCode: this.creditCode }).then(res => {
                    console.log(res)
                    if (res.ret === 0) {
                        this.integrityIndex = res.data
                    }
                })
            },
            // 诚信指数企业品质指数扣分列表
            getQualityIndexDeductionList () {
                api.getQualityIndexDeductionList({ pageIndex: 1, pageSize: 10000, creditCode: this.creditCode }).then(res => {
                    if (res.ret === 0) {
                        // this.quanlityPagination = res.data.pageination;
                        // this.quanlityList = [...this.quanlityList, ...res.data.list];
                        // this.quanlityLoading = false;
                        // if (this.quanlityPagination.currentPage >= this.quanlityPagination.totalPage) {
                        //     this.quanlityFinished = true;
                        // }
                        for (let i = 0; i < res.data.list.length; i++) {
                            res.data.list[i].ratingTime = this.formatDate1(new Date(res.data.list[i].ratingTime))
                        }
                        this.quanlityList = res.data.list
                    }
                })
            },
            add0 (m) { return m < 10 ? '0' + m : m },
            formatDate1 (now) {
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                var date = now.getDate();
                return year + '-' + this.add0(month) + '-' + this.add0(date);
            },
            formatDate2 (now) {
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                var date = now.getDate();
                var hour = now.getHours();
                var minute = now.getMinutes();
                return year + '-' + this.add0(month) + '-' + this.add0(date) + ' ' + this.add0(hour) + ':' + this.add0(minute);
            },
            // // 诚信指数企业品质指数扣分列表加载更多
            // quanlityLoadMore () {
            //     this.getQualityIndexDeductionList()
            // },
            // 最近6个月诚信指数
            getSixMonthIntegrityList () {
                api.getSixMonthIntegrityList({ creditCode: this.creditCode }).then(res => {
                    if (res.ret === 0) {
                        let monthData = []
                        for (var i in res.data) {
                            let obj = {}
                            obj.xAxisMonth = parseInt((i.substring(i.length - 2, i.length - 1) == '0') ? i.substring(i.length - 1) : i.substring(i.length - 2))
                            obj.num = res.data[i]
                            obj.xAxis = i
                            monthData.push(obj)
                        }
                        // 获取当前月份
                        let month = (new Date()).getMonth() + 1
                        // 获取当前月份的前6个月
                        let a = new Array(6)
                        for (let i = 1; i <= a.length; i++) {
                            if (month > 6) {
                                // 当前月份大于6月
                                a[i - 1] = (month - 6 + i);
                            } else {
                                // 当前月份小于等于6月
                                if (month - i < 0) {
                                    a[a.length - i] = (month - i + 13);
                                } else {
                                    a[a.length - i] = (month - i + 1);
                                }
                            }
                        }
                        let monthDatas = new Array(6)
                        monthData.map((items, index) => {
                            for (let i = 0; i < a.length; i++) {
                                if (a[i] == items.xAxisMonth) {
                                    monthDatas[i] = items
                                }
                            }
                        })
                        this.monthData = monthDatas
                    }
                })
            },
            round (num, decimal) {
                if (isNaN(num)) {
                    return 0;
                }
                const p1 = Math.pow(10, decimal + 1);
                const p2 = Math.pow(10, decimal);
                return Math.round(num * p1 / 10) / p2;
            },

            toFixed (num, decimal) {
                return this.round(num, decimal).toFixed(decimal);
            }
        },

        mounted () {
            this.creditCode = this.$route.query.licence || ''
            this.getSixMonthIntegrityList()
            this.getGradeIndex()
            this.getQualityIndexDeductionList()
            this.getCreditIndexDeductionList()
        },
        created () {}
    };
</script>
<style scoped lang="less">
.integrityIndex {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-bottom: 16px;

  .wrapper-box {
    background: rgba(54, 179, 116, 1);
    height: 317px;

    .titles {
      box-sizing: border-box;
      padding: 17px 12px 0 12px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 4px;

      span {
        font-size: 24px;
      }
    }
    .desc {
      box-sizing: border-box;
      padding: 0 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 17px;
      margin-bottom: 4px;
    }
    .price-box {
      box-sizing: border-box;
      padding: 0 12px;
      display: flex;
      align-items: center;

      .tags {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 17px;
        margin-right: 7px;
        margin-bottom: 12px;
      }
    }
    .excel-title {
      box-sizing: border-box;
      padding: 0 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 17px;
      margin-bottom: 5px;
    }
    .excel-box {
    }
  }
  .maincon-box {
    width: 351px;
    min-height: 267px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin-top: -26px;
    margin-left: 12px;
    overflow: hidden;
    .data-card-tab {
      margin-left: 16px;
      margin-bottom: 22px;
      margin-top: 16px;
    }
    .standard-box {
      .small-titles {
        box-sizing: border-box;
        padding: 0 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
      }
      .lists-box {
        .items-box {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 16px;

          .left-box {
            flex: 1;

            .title {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
              margin-bottom: 8px;
            }
            .dates {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }
          .right-box {
            margin-left: 10px;
            .price-box {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin-bottom: 9px;

              .price {
                height: 12px;
                font-size: 12px;
                font-family: DIN-Bold, DIN;
                font-weight: bold;
                color: rgba(255, 77, 77, 1);
                line-height: 12px;
                margin-right: 4px;
              }
              .img-right {
                display: inline-block;
                width: 12px;
                height: 12px;
              }
            }
            .status {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }
        }
      }
    }
    .quality-box {
      .small-titles {
        box-sizing: border-box;
        padding: 0 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 17px;
      }
      .list-items-box{

        .info-box {
          display: flex;
          // align-items: flex-end;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 17px 16px 8px 16px;

          .desc-box {
            .person {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
            }
            .pricestand {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
              margin-top: 8px;
            }
            .dates {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
              margin-top: 8px;
            }
          }
          .price-box {
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .price {
              font-size: 24px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(54, 179, 116, 1);
            }
            .status {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(153, 153, 153, 1);
              line-height: 12px;
            }
          }
        }
        .lists-box {
           box-sizing: border-box;
           padding-bottom: 8px;
          .items-box {
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 16px;

            .namess {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 14px;
            }
            .price {
              font-size: 12px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: rgba(255, 77, 77, 1);
              line-height: 12px;
            }
          }
        }
      }
    }
    .experience-box {
      box-sizing: border-box;
      padding-top: 56px;
      text-align: center;

      .price {
        font-size: 24px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 24px;
        margin-bottom: 14px;
      }
      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 12px;
      }
    }
  }
}
.colorgreen{
  color: #36B374 !important;
}
.colorRed{
  color: #FF4D4D !important;
}
.greycolor{
  color: #999 !important;
}
</style>
